
  import { defineComponent, PropType, reactive, toRefs} from "vue";
  import {OrderOperator} from "@/views/Orders/Operators/OrderOperators.vue";
  import {orderId} from "@/RouterUtils";
  import {AsyncState} from "@/enums";
  import {init} from "@/views/Orders/Operators/OrderOperatorsComposable";

  export default defineComponent({
    name: "OrderOperatorsListQualityLevel",
    props: {
      editable: {
        type: Boolean,
        default: () => false
      },
      item: {
        type: Object as PropType<OrderOperator>,
        default: () => null,
      }
    },
    setup (props, context) {
      const initialState = {
        qualityLevel: props.item.qualityLevel
      };

      const {
        state: generalState,
        createOrUpdate,
        isLoading,
        isError,
        isSuccess,
        $externalResults,
      } = init();

      const state = reactive({ ...initialState });

      const update = () => {
        if (props.editable && props.item.qualityLevel != state.qualityLevel) {
          generalState.asyncState = AsyncState.LOADING;
          createOrUpdate(orderId.value, {
            id: props.item.id,
            employee: props.item.employee,
            operatorNumber: props.item.operatorNumber,
            numberOfPositions: props.item.numberOfPositions,
            qualityLevel: state.qualityLevel,
          })
            .then(updated => {
              context.emit("updated", updated);
            })
            .catch(error => {
              $externalResults.value = {
                qualityLevel: error.response.data.title
              };
              generalState.asyncState = AsyncState.ERROR;
            });

        } else {
          generalState.asyncState = AsyncState.SUCCESS;
        }
      };

      return {
        ...toRefs(state),
        isLoading,
        isError,
        isSuccess,
        update
      };
    }
  });
